import React from 'react';

import HorizontalBars from '../../../components/charts/chartjs/horizontal-bars/HorizontalBars';
import { SONAR_DATA_KEYS } from '../../../utils/chart';
import { getSonarPowerrankData } from '../../../redux/sonar/sonarSelectors';

function Powerrank({ domainEntries }) {
  //! TEMPORARY SOLUTION
  let tempDomainEntries = domainEntries;

  if (domainEntries.length && !domainEntries[0][SONAR_DATA_KEYS.POWERRANK]) {
    tempDomainEntries = [];
  }

  const resultDomainEntries = tempDomainEntries.length ? getSonarPowerrankData(tempDomainEntries) : tempDomainEntries;

  return <HorizontalBars data={resultDomainEntries} dataKey={SONAR_DATA_KEYS.POWERRANK} customTooltip />;
}

export default Powerrank;
